import type { InsightCard as InsightCardData } from "@excellent/core";
import { Count } from "../../count";
import { ListCard } from "../list-card";
import { InsightCard } from "./insight-card";

/**
 * Renders a list of synthesized insights. Sorts by `priority` asc (lower
 * = top), caps at 6, renders the standard empty state when the list is
 * empty. See docs/dashboard/PRD.md §5.3.
 */
export function InsightCardList({
  insights,
  title = "Insights",
  emptyBody = "No insights yet — add a few records and check back.",
}: {
  insights: InsightCardData[];
  title?: string;
  emptyBody?: string;
}) {
  const sorted = [...insights]
    .sort((a, b) => (a.priority ?? 500) - (b.priority ?? 500))
    .slice(0, 6);

  if (sorted.length === 0) {
    return (
      <ListCard title={title} count={0} empty={emptyBody}>
        <></>
      </ListCard>
    );
  }

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-2 px-1 type-body">
        <span className="text-foreground">{title}</span>
        <Count value={sorted.length} />
      </div>
      <div className="flex flex-col gap-2">
        {sorted.map((insight, i) => (
          <InsightCard key={`${insight.title}-${i}`} insight={insight} />
        ))}
      </div>
    </div>
  );
}
